import React, { useRef, useState, useEffect } from 'react';
import TablaPetro from './tablaPetro';

export const Petro = (props) => {
    return (
        <div className='container-fluid rounded p-0 m-0'>
        <div className='container-fluid w-100 h-100 p-0 m-0'>
              <TablaPetro />
           </div>
        </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/valorpetro.js